<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" class="category-attr">
    <template v-if="propConfigs.length">
      <template v-for="(item) in propConfigs">
         <div
          class="attr-item"
          :key="item.property.id">
          <el-form-item
            :prop="`${item.property.id}`"
            :label="item.property.name">
            <el-select
              v-if="[1,5].includes(item.property.valueType)"
              :allow-create="[1].includes(item.property.valueType)"
              multiple
              filterable
              placeholder="请完善"
              v-model="form[item.property.id]">
              <el-option
                v-for="(item, index) in item.property.valueNames"
                :key="item + index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <el-date-picker
              v-else-if="[2].includes(item.property.valueType)"
              v-model="form[item.property.id][0]"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
            <el-input-number
              v-else-if="[3,4].includes(item.property.valueType)"
              v-model="form[item.property.id][0]"
              :controls="false"
              v-bind="3 === item.property.valueType ? {precision: 0} : {}"
            ></el-input-number>
            <MutiImgUpload
              v-else-if="[6].includes(item.property.valueType)"
              v-model="form[item.property.id]"
              :size="300"
              :mainImgNums="0"/>
          </el-form-item>
        </div>
      </template>
    </template>
    <div v-else>暂无属性</div>
    <template>
       <span class="update-brand">找不到商品属性？
            <el-link :underline="false" @click="fetch_props(true)">刷新数据</el-link>
        </span>
    </template>
  </el-form>
</template>

<script>
import {getCategoryProps, _filterInvalidImg} from '@/servers/prod/center/yz.js'
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'youzanCp',
  model: {
    prop: 'values',
    event: 'change'
  },
  components: {
    MutiImgUpload
  },
  props: {
    values: {
      required: true
    },
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      form: {},
      formVoid: true,
      propConfigs: [],
      rules: {},
      categoryIdChange: false,
      categoryId: '',
      cid: '',
    }
  },
  watch: {
    categoryIds: {
      handler(v) {
        this.categoryId = !v.length ? '' : v[v.length - 1]
      },
      immediate: true
    },
    categoryId: {
      handler(v, o) {
        this.propConfigs = []
        this.rules = {}
        this.categoryIdChange = !!o
        this.cid = v;
        v && this.fetch_props()
      },
      immediate: true
    },
    values: {
      immediate: true,
      handler(v) {
        if (!this.propConfigs.length) return ;
        // 根据values生产form
        if (!v || !v.length) {
          this.form = {}
          this.formVoid = true
          return;
        }
        this.formVoid = false
        v.forEach(item => {
          let _value = item.val_names
          this.$set(this.form, item.id, _value)
        })
      }
    },
    form: {
      deep: true,
      handler(v) {
        if (!this.propConfigs.length) return ;
        let _values = (this.values && this.values.length) ? JSON.parse(JSON.stringify(this.values)) : false

        if (!_values) return;
        _values = _values.map(item => {
          let _new_value = v[item.id]
          let _item = {
            ...item
          }
          _item.val_names = _new_value
          return _item
        })

        this.$emit('change', _values)
      }
    }
  },
  methods: {
    ...mapActions(["updateCatePropShopIndex"]),
    async fetch_props(isUpdate) {
      isUpdate && this.updateCatePropShopIndex("yz")
      let res = await getCategoryProps({categoryId: this.cid})
      
      if (res?.result?.publicPropertys) {
        this.propConfigs = res.result.publicPropertys.filter(item => item.propertyGroup === 1)
        this.initValues(this.propConfigs)
      } else {
        return false;
      }
    },
    // 初始化类目属性数据结构
    initValues(propConfigs) {

      let init_values = []
      propConfigs?.forEach(item => {
        let v = {
          id: item.property.id,
          pro_name: item.property.name,
          val_names: [],
        }

        let oldValue = this.values.find(v => `${v.id}` === `${item.property.id}`)
        if (oldValue && !this.categoryIdChange) {
          if (oldValue.prop_name) {
            oldValue.pro_name = oldValue.prop_name
            delete oldValue.prop_name
          }
          // 老值回显问题
          init_values.push(oldValue)
        } else {
          init_values.push(v)
        }
        this.setRulesByPropConfig(item)
      })
      if (this.categoryIdChange || !(this.values && this.values.length)) {
        this.$emit('change', init_values)
        this.categoryIdChange = false
      } else {
        this.$emit('change', init_values)
      }
    },
    setRulesByPropConfig(config) {
      let rules = []
      if (config.isRequired) {
        rules.push({ required: true,  validator: this._genRequired(config), message: `请完善${config.property.name}` })
      }
      this.$set(this.rules, config.property.id, rules)
    },
    // 生成校验必填校验
    _genRequired(config) {
      return function(rule, value, callback) {
        if (!value || !value.length) {
          callback(new Error(`请完善${config.property.name}`))
        } else {
          callback()
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.category-attr {
  align-items: flex-start;
  position: relative;
  .attr-item {
    width: 245px !important;
    margin-bottom: 28px !important;
  }

  ::v-deep .el-form-item__label {
    padding: 0;
  }
   .update-brand {
        position: absolute;
        left: 20px;
        bottom: 0px;
        font-size: 12px;
    }
}
</style>